<!--
 * @Descripttion: 路由切换区
 * @Author: chenjinsheng
 * @Date: 2021-08-05 09:06:40
 * @LastEditors: chenjinsheng
 * @LastEditTime: 2021-10-26 10:59:20
-->
<template>
    <div class="page-router page-router-gray-manage">
        <!--路由切换区-->
        <div class="project-router clear_before">
            <keep-alive>
                <router-view v-if="$route.meta.keepAlive" />
            </keep-alive>
            <router-view v-if="!$route.meta.keepAlive" />
        </div>
    </div>
</template>

<script>
export default {
    name: "PageRouter",
    computed: {},
};
</script>

<style lang="scss" scoped>
.page-router {
    width: 100%;
    height: 100%;
}
.page-router-gray-manage {
    height: 100%;
    .project-router {
        width: 100%;
        height: 100%;
    }
}
</style>
